import * as React from "react";
import { useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CheckEligibility from "./Eligibility/CheckEligibility";
import PreAuthorization from "./Authorization/PreAuthorization";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Patient from "./patient";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import Home from "./Home";
import HomeIcon from "@mui/icons-material/Home";
import MenuItem from "@mui/material/MenuItem";
import HistoryIcon from "@mui/icons-material/History";
import Eligibilityhistory from "./Eligibility/EligibilityHistory";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AuthorizationHistory from "./Authorization/AuthorizationHistory";
import PriceListManagment from "./Authorization/priceListManagment";
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import ClaimHistory from "./ClaimSubmission/ClaimHistory";
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
const EligibilityDropdown = ({ isOpen, onClose, onSelectOption }) => {
  return (
    <div style={{ padding: "0 0 0 50px" }}>
      <MenuItem onClick={() => onSelectOption("Check Eligibility")}>
        <DownloadDoneIcon style={{ marginRight: "10px", fontSize: "13px" }} />
        Check Eligibility
      </MenuItem>
      <MenuItem onClick={() => onSelectOption("History")}>
        <HistoryIcon style={{ marginRight: "10px", fontSize: "13px" }} />
        History
      </MenuItem>
    </div>
  );
};
const AuthorizationDropdown = ({ isOpen, onClose, onSelectOption }) => {
  return (
    <div style={{ padding: "0 0 0 50px" }}>
      <MenuItem onClick={() => onSelectOption("Authorization")}>
        <ArrowUpwardIcon style={{ marginRight: "10px", fontSize: "13px" }} />
        Authorization
      </MenuItem>
      <MenuItem onClick={() => onSelectOption("Authorization History")}>
        <HistoryIcon style={{ marginRight: "10px", fontSize: "13px" }} />
        History
      </MenuItem>
      <MenuItem onClick={() => onSelectOption("Price List")}>
        <PriceCheckIcon style={{ marginRight: "10px", fontSize: "13px" }} />
        Price List
      </MenuItem>
      
    </div>
  );
};
const ClaimDropdown = ({ isOpen, onClose, onSelectOption }) => {
  return (
    <div style={{ padding: "0 0 0 50px" }}>
      <MenuItem onClick={() => onSelectOption("Claim History")}>
        <HistoryIcon style={{ marginRight: "10px", fontSize: "13px" }} />
        History
      </MenuItem>
    </div>
  );
};
export default function SideNav(props) {
  const isAuthenticated = Cookies.get("id");
  const navigate = useNavigate();

  if (!isAuthenticated) {
    navigate("/");
  }

  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [menuData, setMenuData] = useState("Home");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownAuthOpen, setDropdownAurhOpen] = useState(false);
  ////////////////////////////////
  const [dropdownClaimOpen, setDropdownClaimOpen] = useState(false);

  const [selectedDropdownOption, setSelectedDropdownOption] = useState(null);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDropdownOptionSelect = (option) => {
    setSelectedDropdownOption(option);
    setMenuData(`${option}`);
  };
  const handleEligibilityClick = () => {
    // setMenuData("Eligibility");
    setDropdownOpen(!dropdownOpen);
  };
  const handleAuthClick = () => {
    // setMenuData("Eligibility");
    setDropdownAurhOpen(!dropdownAuthOpen);
  };
  ///////////
  const handleClaimClick = () => {
    setDropdownClaimOpen(!dropdownClaimOpen);
  };
  const handleDropdownClose = () => {
    setDropdownOpen(false);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const logoutBtn = () => {
    Cookies.remove("id");
    navigate("/");
  };
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open} style={{ backgroundColor: "white" }}>
        <Toolbar>
          <IconButton
            style={{ color: "grey" }}
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            style={{ color: "grey" }}
          >
            Amaan Connector
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader style={{ backgroundColor: "white" }}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon style={{ color: "grey" }} />
            ) : (
              <ChevronLeftIcon style={{ color: "grey" }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          <ListItem button onClick={() => setMenuData("Home")}>
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem button onClick={() => setMenuData("Patient")}>
            <ListItemIcon>
              <PersonAddIcon />
            </ListItemIcon>
            <ListItemText primary="Patient" />
          </ListItem>
          <ListItem button onClick={handleEligibilityClick}>
            <ListItemIcon>
              <ArrowDropDownIcon />
            </ListItemIcon>
            <ListItemText primary="Eligibility" />
          </ListItem>
          {dropdownOpen && (
            <EligibilityDropdown
              isOpen={dropdownOpen}
              onClose={handleDropdownClose}
              onSelectOption={handleDropdownOptionSelect}
            />
          )}
          <ListItem button onClick={handleAuthClick}>
            <ListItemIcon>
              <ArrowDropDownIcon />
            </ListItemIcon>
            <ListItemText primary="Pre Authorization" />
          </ListItem>
          {dropdownAuthOpen && (
            <AuthorizationDropdown
              isOpen={dropdownAuthOpen}
              onClose={handleDropdownClose}
              onSelectOption={handleDropdownOptionSelect}
            />
          )}
          {/* k /////////*/}
          <ListItem button onClick={handleClaimClick}>
            <ListItemIcon>
              <ArrowDropDownIcon />
            </ListItemIcon>
            <ListItemText primary="Claim Submission" />
          </ListItem>
          {dropdownClaimOpen && (
            <ClaimDropdown
              isOpen={dropdownClaimOpen}
              onClose={handleDropdownClose}
              onSelectOption={handleDropdownOptionSelect}
            />
          )}

          <ListItem button onClick={logoutBtn}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Drawer>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: menuData === "Home" ? 0 : 3 }}
      >
        {menuData === "Home" && <Home />}
        {menuData === "Patient" && <Patient />}
        {menuData === "History" && <Eligibilityhistory />}
        {menuData === "Check Eligibility" && <CheckEligibility />}
        {menuData === "Authorization" && <PreAuthorization />}
        {menuData === "Authorization History" && <AuthorizationHistory />}
        {menuData === "Price List" && <PriceListManagment />}
        
        {menuData === "Claim History" && <ClaimHistory />}

      </Box>
    </Box>
  );
}
